export const formatRating = (value?: number | null): string => {
  const numeric = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(numeric)) {
    return '0.0';
  }
  return numeric.toFixed(1);
};

export const formatRatingChange = (value?: number | null): string => {
  const numeric = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(numeric)) {
    return '0.0';
  }
  const fixed = Math.abs(numeric).toFixed(1);
  if (numeric > 0) {
    return `+${fixed}`;
  }
  if (numeric < 0) {
    return `-${fixed}`;
  }
  return fixed;
};

export const formatScore = (value?: number | null): string => {
  const numeric = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(numeric)) {
    return '0';
  }
  return Math.round(numeric).toString();
};

// Billing dates are UTC instants; show them as the Melbourne calendar date.
export const formatBillingDate = (value: string): string =>
  new Date(value).toLocaleDateString('en-AU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'Australia/Melbourne',
  });
